module.exports = __webpack_public_path__ + "static/media/Customer.6db20dc7.svg";